import axios from 'axios';
import React, { useEffect, useState } from 'react'
import apiClient from '../../../utils/apiclient';
import { useNavigate } from 'react-router-dom';

const CompletedSubscriptons = (route) => {
  const isAdmin = localStorage.getItem("bentoAdminDetails") == 4 ? true : false;

   const [editingId, setEditingId] = useState(null);
  const [editDates, setEditDates] = useState({
    startdate: "",
    enddate: "",
    expirydate: "",
    noteByAdmin: "",
  });
  const handleDateChange = (e) => {
  const { name, value } = e.target;
  setEditDates((prev) => ({
    ...prev,
    [name]: value,
  }));
};
  const handleEdit = (row) => {
  setEditingId(row.id);
  setEditDates({
    startdate: row.startdate,
    enddate: row.enddate,
    expirydate: row.expirydate||"",
    noteByAdmin: row.noteByAdmin || "",
  });
};
const handleSave = async (subscriptionId) => {
  try {
    const payload = {
      startdate: editDates.startdate,
      enddate: editDates.enddate,
      expirydate: editDates.expirydate,
      noteByAdmin: editDates.noteByAdmin, 
    };

    // console.log(payload)
    const response=await apiClient.put(
      `/subscription/update-dates/${subscriptionId}`,
      payload
    );
// console.log(response.data)
    setData2((prev) =>
      prev.map((item) =>
        item.id === subscriptionId
          ? { ...item, ...payload }
          : item
      )
    );

    setEditingId(null);
  } catch (e) {
    console.error(e);
    alert("Failed to update dates");
  }
};
    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);
    const [search, setSearch] = useState("");
    const navigate = useNavigate()
      useEffect(() => {
        const tableData = async () => {
          try {
            const url = `${route.route}${search ? `?search=${encodeURIComponent(search)}` : ''}`;
            const historyresponse = await apiClient.get(url);
            const response = await apiClient.get(
 `CompletedSubscription${search ? `?search=${encodeURIComponent(search)}` : ''}`            );
    console.log("response.data",response.data);
            setData(historyresponse.data);
            setData2(response.data);
            // console.log(historyresponse.data);
            
          } catch (e) {
            console.error(e);
          }
        };
        tableData();
      }, [route.route, search]);

  const handlechange = (e) => {
    setSearch(e.target.value);
  };
  return (
    <div className="w-full flex-1 flex flex-col min-h-0">
      <div className="flex justify-between items-center mb-2 flex-shrink-0 gap-3">
        <h2 className="text-base md:text-xl font-semibold text-gray-800 whitespace-nowrap">Completed Subscriptions</h2>
        <input className="flex-1 border-2 py-1.5 px-3 md:py-2 md:px-4 text-sm md:text-base rounded-lg outline-none focus:border-blue-500 min-w-0"
          placeholder='Search...'
          onChange={handlechange}
          value={search}
        />
      </div>
      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className='min-w-max w-full bg-white shadow-md border-collapse'>
        <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
          <tr>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Subscription ID</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">User ID</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">User Number</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">User Name</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Meal Plan</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Meal Plan Name</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Meal Plan Type</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Restaurant Name</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Active Status</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Start Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">End Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Count</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Max Count</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Pause Status</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Cancellation Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Expired On Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Completion Date</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Non Discounted Price</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Price</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Coins</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Discount Value</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Refund Amount</th>
            <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Admin Notes</th>
            {isAdmin && (  
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold whitespace-nowrap text-center">Action</th>
            )}
          </tr>
      </thead>
      <tbody>
        {
          data2.map((data,index)=>(
        
            <tr key={index} className='items-center justify-center border border-gray-300'>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.id}</td>
               <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.userid}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer" onClick={()=>{navigate(`/userDetails/${data.number}`)}}>{data.number}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.userdetails.name}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealPLanName}</td>
                            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplandetails.name}</td>

                            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplantype==1?"Lunch":"Dinner"}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline" onClick={()=>{navigate(`/restaurant/${data.restaurantid}`)}}>{data.restaurantName}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.isActive ? "Active":"Not Active"}</td>
             
           
           <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <input
      type="date"
      name="startdate"
      value={editDates.startdate}
      onChange={(e) =>
        setEditDates({ ...editDates, startdate: e.target.value })
      }
      className="border px-1"
    />
  ) : (
    data.startdate
  )}
</td>

<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <input
      type="date"
      name="enddate"
      value={editDates.enddate}
      onChange={(e) =>
        setEditDates({ ...editDates, enddate: e.target.value })
      }
      className="border px-1"
    />
  ) : (
    data.enddate
  )}
</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealcount}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.maxmealcount}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.ispaused==null?"Yes" : "No"}</td>
        {console.log(data.cancellationdate)}
              
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.cancellationdate==null?"-":data.cancellationdate}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.expiredOn==null?"-":data.expiredOn}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.completiondate==null?"-":data.completiondate}</td>

<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.nonDiscountedPrice}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.price}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.coinsUsed}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.discountvalue}</td>              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.refundAmount===null?"-":data.refundAmount}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <textarea
      name="noteByAdmin"
      value={editDates.noteByAdmin}
      onChange={handleDateChange}
      className="border px-1 w-40"
    />
  ) : (
    data.noteByAdmin || "-"
  )}
</td>
{(isAdmin) && (
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">
  {editingId === data.id ? (
    <>
      <button
        className="text-green-600 mr-2"
        onClick={() => handleSave(data.id)}
      >
        Save
      </button>
      <button
        className="text-red-600"
        onClick={() => setEditingId(null)}
      >
        Cancel
      </button>
    </>
  ) : (
    <button
      className="text-blue-600 underline"
      onClick={() => handleEdit(data)}
    >
      Edit
    </button>
  )}
</td>
)}
            </tr>
          ))
        
        }
         {
          data.map((data,index)=>(
        
            <tr key={index} className='items-center justify-center border border-gray-300'>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.id}</td>
               <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.userid}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer" onClick={()=>{navigate(`/userDetails/${data.number}`)}}>{data.number}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealPLanName}</td>
                                   <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealPLanName}</td>
                   

                            <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealplantype==1?"Lunch":"Dinner"}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center hover:text-blue-900 hover:cursor-pointer hover:underline" onClick={()=>{navigate(`/restaurant/${data.restaurantid}`)}}>{data.restaurantName}</td>

              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.isActive ? "Active":"Not Active"}</td>
             
           
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.startdate}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.enddate}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.mealcount}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.maxmealcount}</td>
                           <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.cancellationDate==null?"No":"Yes"}</td>
                                           <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.cancellationDate?data.cancellationDate:"-"}</td>
                          
                                           <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.cancellationDate?data.cancellationDate:"-"}</td>
                          
                                           <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.cancellationDate?data.cancellationDate:"-"}</td>

<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.nonDiscountedPrice}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.price}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.coinsused}</td>
        <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.discountvalue}</td>              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">{data.refundAmount===null?"-":data.refundAmount}</td>
<td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center">

</td>
            </tr>
          ))
        
        }
        </tbody>
        </table>
      </div>
        </div>
  )
}

export default CompletedSubscriptons